import { useRouter } from 'next/router'
import { withNoSSR } from '../../src/components/withNoSSR'
import React from 'react'

const Index = withNoSSR(() => {
  const router = useRouter()

  // TODO: add ssr redirect?
  const dealerId = router.query.dealer

  if (dealerId) {
    router.replace(`/dealer/${dealerId}${window.location.search}`)
  } else {
    // TODO: add 404 redirect
    // init render has no query params
    // router.push('/page-not-found')
  }

  return <div />
})
export default Index
